<div class="success-container">
  <mat-icon class="success-icon">check_circle</mat-icon>
  <h2>Form submitted successfully!</h2>
  <p>Thank you! The form has been submitted successfully.<br>We will reply to you soon!</p>
 
</div>
